export class SalidaDetalleCombustible {
    codigoContenedor: string;
    volumen: number;
    volumen15: number;
    aforadorInicial: number;
    aforadorFinal: number;
    picoId: string;
  }